import { I as Icon, _ as _extends } from './Icon-f29ff1c6.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Check = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M19.7832 7.7562c.391-.391.391-1.025 0-1.416s-1.025-.391-1.416 0l-9.2001 9.2-3.5387-3.5387c-.3903-.3902-1.023-.3902-1.4131 0-.3902.3902-.3902 1.0229 0 1.4131l4.247 4.2471a.9997.9997 0 001.1127.2067.998.998 0 00.3048-.2088l9.9034-9.9034z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M19.7832 7.7562c.391-.391.391-1.025 0-1.416s-1.025-.391-1.416 0l-9.2001 9.2-3.5387-3.5387c-.3903-.3902-1.023-.3902-1.4131 0-.3902.3902-.3902 1.0229 0 1.4131l4.247 4.2471a.9997.9997 0 001.1127.2067.998.998 0 00.3048-.2088l9.9034-9.9034z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M19.7832 7.7562c.391-.391.391-1.025 0-1.416s-1.025-.391-1.416 0l-9.2001 9.2-3.5387-3.5387c-.3903-.3902-1.023-.3902-1.4131 0-.3902.3902-.3902 1.0229 0 1.4131l4.247 4.2471a.9997.9997 0 001.1127.2067.998.998 0 00.3048-.2088l9.9034-9.9034z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Check.displayName = "CheckIcon";

export { Check, Check as default };
